import { InputCheckbox } from "@components/common/form/input-checkbox/input-checkbox";
import { useTheme } from "@components/common/hooks/theme";
import { Night } from "@components/common/icons/night";
import { Sun } from "@components/common/icons/sun";
import { FunctionComponent } from "react";

export const ThemeSwitch: FunctionComponent = () => {
    const { mode, toggleMode } = useTheme();

    return (
        <label
            htmlFor="switchMode"
            className="hidden h-7 cursor-pointer items-center gap-x-1.5 rounded-[17px] bg-gray-50 px-2 transition-colors duration-300 ease-out-cubic lg:flex"
        >
            <div>
                <Sun className="size-3 text-orange-500" />
            </div>
            <div className="flex align-top">
                <InputCheckbox
                    checked={mode === "dark"}
                    id="switchMode"
                    checkSwitch={true}
                    rounded="full"
                    size="sm"
                    onChange={() => toggleMode(mode === "dark" ? "light" : "dark")}
                />
            </div>
            <div>
                <Night className="size-3 text-gray-950" />
            </div>
        </label>
    );
};
